import { RECEIPT_DETAILS_SUCCEEDED, RECEIPT_DETAILS_FAILED, CLEAR_RECEIPT_DETAILS, RECEIPT_DETAILS_REQUESTED } from '../actions/receipt'

const initialState =  {
    loading: true,
    failed: false,
}

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case RECEIPT_DETAILS_REQUESTED: {
      return {
        loading: true,
        failed: false,
      }
    }

    case RECEIPT_DETAILS_SUCCEEDED: {
      return {
        ...payload,
        loading: false,
        failed: false,
      }
    }

    case RECEIPT_DETAILS_FAILED: {
      return {
        ...payload,
        loading: false,
        failed: true,
      }
    }

    case CLEAR_RECEIPT_DETAILS: {
      return initialState
    }

    default:
      return state
  }
}
